<template>
    <div id="data-list-list-view" class="data-list-container">


        <vs-table ref="table" pagination :max-items="15" :data="list">

            <template slot="thead">
                <vs-th>Transaction Code</vs-th>
                <vs-th>Date</vs-th>
                <vs-th>Order Number</vs-th>
                <vs-th>Price</vs-th>
                <vs-th>Gateway</vs-th>
                <vs-th>Status</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
                    <vs-td>
                        <p class="product-name font-medium truncate">CBS_TR-{{ tr.id }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="product-category">{{ tr.created_at }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="product-price">CBS_ORDER-{{ tr.order_id }} </p>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                        <span>{{tr.price | price}}</span>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                        <span>{{tr.bank}}</span>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                        <vs-chip :color="getOrderStatusColor(tr.sts)" class="product-order-status">
                            {{ tr.sts_str }}
                        </vs-chip>
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                // products: [],
                itemsPerPage: 4,
                isMounted: false,

                // Data Sidebar
                addNewDataSidebar: false,
                sidebarData: {},
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            list() {
                return this.$store.state.transaction.list
            }
        },
        methods: {
            getOrderStatusColor(status) {
                if (status == -1) return "warning"


                if (status == 0) return "success"
                if (status == -2) return "danger"
                return "primary"
            },
            getPopularityColor(num) {
                if (num > 90) return "success"
                if (num > 70) return "primary"
                if (num >= 50) return "warning"
                if (num < 50) return "danger"
                return "primary"
            },
        },
        created() {
            // if (!moduleTransaction.isRegistered) {
            //     this.$store.registerModule('transaction', moduleTransaction)
            //     moduleTransaction.isRegistered = true
            // }
            this.$store.dispatch("transaction/fetch")
        },
        mounted() {
            this.isMounted = true;
        }
    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            right: 1rem;
                        }

                        &:focus + i {
                            right: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 20px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
